import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../locale/jsonMessages';
import Link from '../Link';
import Loader from '../Loader';
import InspectionBanner from './InspectionBanner/InspectionBanner';
import ReservationSummaryCard from './ReservationSummaryCard/ReservationSummaryCard';
import { windowReasonKey } from '../../helpers/inspectionPresentation';
import s from './Inspection.css';

// Common frame of the check-in / check-out pages: back link, title, loading / not found / error / feature switched off,
// then the reservation reminder (R1) and the page content.
export function InspectionShell({ title, subtitle, state, children, bannerWhenClosed }) {
  const { formatMessage } = useIntl();
  const isOwner = state.kind === 'ready' && state.result.viewerRole === 'host';
  const back = isOwner ? '/reservation/current' : '/trips/current';
  const header = (
    <>
      <Link to={back} className={s.backLink}>{'← '}{formatMessage(messages.inspBackToReservations)}</Link>
      <h1 className={s.title}>{title}</h1>
      {subtitle && <p className={s.subtitle}>{subtitle}</p>}
    </>
  );

  if (state.kind === 'loading') return <div className={s.page}>{header}<Loader type="text" /></div>;
  if (state.kind === 'notLoggedIn') {
    return <div className={s.page}>{header}<InspectionBanner tone="danger" title={formatMessage(messages.inspNotLoggedIn)} /></div>;
  }
  if (state.kind === 'notFound') {
    return <div className={s.page}>{header}<InspectionBanner tone="danger" title={formatMessage(messages.inspNotFound)} /></div>;
  }
  if (state.kind === 'error') {
    return <div className={s.page}>{header}<InspectionBanner tone="danger" title={state.errorMessage || formatMessage(messages.inspLoadFailed)} /></div>;
  }
  const { reservation, result } = state;
  const disabled = reservation.inspectionEnabled === false || result.windowReason === 'inspectionDisabled';
  return (
    <div className={s.page}>
      {header}
      {disabled
        ? <InspectionBanner tone="neutral" title={formatMessage(messages.inspWindowDisabled)} />
        : (
          <>
            <ReservationSummaryCard reservation={reservation} />
            {bannerWhenClosed && !result.windowOpen && !state.inspection && (
              <InspectionBanner tone="info" title={formatMessage(messages[windowReasonKey(result.windowReason)])} />
            )}
            {children}
          </>
        )}
    </div>
  );
}

InspectionShell.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  state: PropTypes.object.isRequired,
  bannerWhenClosed: PropTypes.bool
};

export default withStyles(s)(InspectionShell);
